module.exports = __webpack_public_path__ + "img/bgAssocie.f9fb194c.webp";